//地址组件映射表，apiData=>router.addRoutes([])动态添加


export default {
    //系统管理=>
    "/sys/menu": {
        component: () => import("@/views/f2_system/p1_menu"),
        title: "菜单管理",
        name: "Sys_Menu",
    },
    "/sys/user": {
        component: () => import("@/views/f2_system/p2_user"),
        title: "用户管理",
        name: "Sys_User",
    },
    "/sys/dept": {
        component: () => import("@/views/f2_system/p3_dept"),
        title: "部门管理",
        name: "Sys_Dept",
    },
    "/sys/role": {
        component: () => import("@/views/f2_system/p4_role"),
        title: "角色管理",
        name: "Sys_Role",
    },
    "/sys/unit": {
        component: () => import("@/views/f2_system/p5_unit"),
        title: "单位管理",
        name: "Sys_Unit",
    },
    "/sys/config": {
        component: () => import("@/views/f2_system/p9_config"),
        title: "系统设置",
        name: "Sys_Config",
    },
    //八大员=>
    "/eight/teacherManagement": {
        component: () => import("@/views/f8_manager/p3_teacherManagement.vue"),
        title: "教师管理",
        name: "TeacherManagement",
    },
    "/eight/studentManagement": {
        component: () => import("@/views/f8_manager/p6_studentManagement.vue"),
        title: "学生管理",
        name: "StudentManagement",
    },
    "/eight/batchManagement": {
        component: () => import("@/views/f8_manager/p14_batchManagement.vue"),
        title: "批次管理",
        name: "BatchManagement",
    },
    "/eight/system_message": {
        component: () => import("@/views/f8_manager/p12_system_message.vue"),
        title: "系统消息",
        name: "System_message",
    },
    //内容管理=>
    "/eight/course": {
        component: () => import("@/views/f8_manager/p8_course.vue"),
        title: "推荐课程管理",
        name: "Course",
    },
    "/eight/friendLink": {
        component: () => import("@/views/f8_manager/p9_friendLink.vue"),
        title: "友链管理",
        name: "FriendLink",
    },
    "/eight/system_nav": {
        component: () => import("@/views/f8_manager/p10_system_nav.vue"),
        title: "导航管理",
        name: "System_nav",
    },
    "/eight/categoryList": {
        component: () => import("@/views/f8_manager/p11_categoryList.vue"),
        title: "文章管理",
        name: "CategoryList",
    },
    //课程管理=>
    "/eight/courseClass": {
        component: () => import("@/views/f8_manager/p1_courseClass.vue"),
        title: "课程分类",
        name: "CourseClass",
    },
    "/eight/discipline": {
        component: () => import("@/views/f8_manager/p2_discipline.vue"),
        title: "学科专业",
        name: "Discipline",
    },
    "/eight/courseManagement": {
        component: () => import("@/views/f8_manager/p4_courseManagement.vue"),
        title: "课程管理",
        name: "CourseManagement",
    },
    //班级管理=>
    "/eight/classManagement": {
        component: () => import("@/views/f8_manager/p5_classManagement.vue"),
        title: "班级管理",
        name: "ClassManagement",
    },
    "/eight/classStudentManagement": {
        component: () => import("@/views/f8_manager/p7_classStudentManagement.vue"),
        title: "班级学生管理",
        name: "ClassStudentManagement",
    },
    "/eight/faceLog": {
        component: () => import("@/views/f8_manager/p13_studentCapture.vue"),
        title: "学生抓拍查看",
        name: "StudentCapture",
    }
}


// WEBPACK FOOTER //
// ./src/router/path_comp_Map.js